import { InferType, array, object, string } from 'yup';

export type ShareReportFieldValues = InferType<typeof shareReportSchema>;

export const shareReportSchema = object({
  id: string().required(),
  targetUsers: array<{ label: string; value: string }>().defined(),
}).required();
